export const zeroPadding = (num: number): string => (('0' + num.toString()).slice(-2))
